import * as Api from "@api";
import * as C from "@components";
import React from "react";
import css from "./product-profile.module.scss";

export const ProductProfileCardContentKeys = [
    "product-profile.headline",
] as const satisfies Api.ContentKey[];

interface ProductProfileCardProps extends React.ComponentProps<typeof C.Card>
{
    cloud: number;
    flavor: number;
    pageContent: Api.Content<typeof ProductProfileCardContentKeys[number]>;
    price: number;
}

export const ProductProfileCard = ({ flavor, cloud, pageContent, price }: ProductProfileCardProps): React.FunctionComponentElement<ProductProfileCardProps> =>
{
    return (
        <C.Card className={css["card"]} layout={{ all: { width: C.Width.W100P }, ipad: { width: C.Width.W55P } }} useWrapper>
            <C.PageContent {...pageContent["product-profile.headline"]} centered typography={C.Typography.H5} />
            <div className={css["profile"]}>
                <C.ProgressBar caption="Flavor" captionWidth={C.Width.W80} progress={flavor} />
                <C.ProgressBar caption="Cloud" captionWidth={C.Width.W80} progress={cloud} />
                <C.ProgressBar caption="Price" captionWidth={C.Width.W80} progress={price} />
            </div>
        </C.Card>
    );
}